import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import { useDeleteContact } from "~/gen/api/hooks"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteContactMutation = ({
  searchSupplier: _searchSupplier,
}: {
  searchSupplier: string
}) => {
  const { t } = useTranslation("organizationSettings")

  return useDeleteContact({
    mutation: {
      onSuccess: async () => {
        showSuccessNotification({
          title: t("supplierSettings.deleteSupplier.success.title"),
          message: t("supplierSettings.deleteSupplier.success.message"),
        })
        await queryClient.invalidateQueries({
          queryKey: [{ url: "/v1/client-settings/find-supplier-mapping" }],
        })
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          showAxiosError({
            notificationTitle: t("supplierSettings.deleteSupplier.error"),
            showNotification: true,
            error,
          })
        }
      },
    },
  })
}
